
<drag
    :data="dragData"
    :type="dragType"
    @dragend = "onDragend"
    @cut     = "onCut"
    :key="dragData ? dragData.id : 0"
>
    <v-card
        flat
        rounded
        :ripple = "false"
        :class  = "background"
        @click  = "onSelect"
        @contextmenu="onContext"
    >
        <div
            :class ="borderWidth + (border ? ' lm-border' : '')"
            :style = "'height: ' + height + 'px'"
        >
            <!--  Title-->
            <div class="v-flex w-100" :style="'height: ' + titleHeight + 'px'">
                <div class="mr-1" v-if="icon.label">
                    <v-menu
                        open-on-hover
                        bottom
                        offset-y
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <b
                                v-bind="attrs"
                                v-on="on"
                            >
                                <c-tag
                                    :label            = "icon.label"
                                    :active           = "icon.active"
                                    :background-color = "highlightColor"
                                />
                            </b>
                        </template>

                        <slot name="tag" />
                    </v-menu>
                </div>
                <div
                    class="card-title v-flex"
                    :class="highlightColor + '--text'"
                    :style="titleStyle">
                    <slot name="title" />
                </div>

                <v-spacer />

                <slot name="toolbar" />
                <a @click.stop="onEdit" v-if="edit">
                    <v-icon
                        :color = "highlightColor"
                        size  = "20"
                        style = "margin-top: -2px"
                        class = "toolbar-button"
                    >
                        mdi-pencil
                    </v-icon>
                </a>
                <slot name="buttons" />
            </div>
            <!--  Title-->

            <!-- Subtitle -->
            <div
                class  = "card-subtitle"
                style  = "margin-top: -1px"
            >
                <slot name="subtitle" />
            </div>
            <!-- Subtitle -->

            <div class="card-body">
                <slot name="body" />
            </div>

            <div class="card-footer">
                <slot name="footer" />
            </div>
        </div>
    </v-card>
</drag>
